import React, { Component } from 'react'
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";
import AdminPriceTable from "./components/AdminPriceTable"
import { AddButton } from 'app/components/Button/AddButton';


import {
  selectAdminPriceData,
  selectAdminPriceLoad
} from "./redux/selector";


const AdminPrice = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();

const rows = useSelector(selectAdminPriceData)
const loading = useSelector(selectAdminPriceLoad) 

useInjectReducer({
  key: sliceKey,
  reducer,
});




    
  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.INVENTORY")} iconPosition="end" />
            <Box>
              <AddButton label={t(("ADMIN_PRICE.ADD"))}/>
            </Box>
            <AdminPriceTable rows={rows} loading={loading} />
          </Box>
        </Box>
    </Box>
  )
}

export default AdminPrice
